// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1__ccc6a3749729fdf13354","cls2":"PaperSelector-cls2__e5b83ca21a63924a120e PaperSelector-cls1__ccc6a3749729fdf13354"};